<ziro-loading-block [hidden]="!isLoading" class="m-auto"></ziro-loading-block>
@if (!isLoading) {
  <div>
    @if (pageDisabled) {
      <div
        class="offset-md-1 col-md-10 ziro-page-alert alert border-warning"
        data-automation="ziro-page-disabled-alert"
      >
        <i class="{{ ziroIcons.WARNING_TRIANGLE }} text-warning fa-4x"></i>
        <div class="ms-3" [innerHTML]="'tkey;userdetail.home.services.disabled_service.label' | escapeHtml"></div>
      </div>
    }
    @if (!pageDisabled) {
      <div>
        <ziro-loading-block [hidden]="isReady"></ziro-loading-block>
        @if (isReady) {
          <ziro-microsoft-365-info-licenses
            [licenseConfig]="licenseConfig"
            [microsoft365UserLicenses]="userLicenses"
            [initialData]="initialData"
            [userSecurityGroups]="userSecurityGroups"
            [microsoft360View]="microsoft360View"
            [tenantId]="tenantId"
          ></ziro-microsoft-365-info-licenses>
        }
      </div>
    }
  </div>
}
